import { render, staticRenderFns } from "./InvoiceEntryView.vue?vue&type=template&id=1b4c87f3"
import script from "./InvoiceEntryView.vue?vue&type=script&lang=ts"
export * from "./InvoiceEntryView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports